export class CoverPage {
  idTarjeta: string = '0';
  nombre: string = '';
  profesion: string = '';
  descripcionTarjeta: string = '';
  Empresa?: string = '';
  colorTarjeta: string = '';
  colorLetra: string = '';
  colorFlecha?: string = '';
  fondoFlecha?: string = '';
  esHorizontal: string = '0';
  habilitado: string = '1';
  urlFotoPerfil: File | '' = '';
  urlPerfilTemp: string = '';
  urlBanner: File | '' = '';
  esHorizontalTemp: string = '0';
  urlBannerTemp: string = '';
  urlLogotipoTemp: string = '';
  urlLogotipo: File | '' = '';
  idUsuario: string = '0';
  idioma: string = 'esp';

  popUpHabilitado: number = 0;
  tituloHabilitado: number = 0;
  tituloPopUp: string = ''; 
  preguntaHabilitado: number = 0;
  pregunta: string = '';
  respuestas: any = [];
  imagenPopUp: File | '' = '';
  imagenUrl: string = ''
  eliminarFoto: number = 0;
  constructor(input?: any) {
    if (input) {
      const props = Object.getOwnPropertyNames(new CoverPage());
      const propsInput = Object.keys(input);
      propsInput.forEach((propInput) => {
        if (!props.includes(propInput)) {
          delete input[propInput];
        }
      });
      Object.assign(this, input);
      return this;
    }

    // this.idTarjeta = '0';
    // this.nombre = '';
    // this.esHorizontal = '2';
    // this.esHorizontalTemp = '0';
    // this.profesion = '';
    // this.Empresa = '';
    // this.descripcionTarjeta = '';
    // // this.colorLetra = '#ffffff';
    // this.colorLetra = '';
    // // this.colorTarjeta = '#272A3F';
    // this.colorFlecha = '';
    // this.fondoFlecha = '';
    // this.colorTarjeta = '';
    // this.habilitado = '1';
    // this.urlFotoPerfil = '';
    // this.urlPerfilTemp = '';
    // this.urlBanner = '';
    // this.urlBannerTemp = '';
    // this.urlLogotipoTemp = '';
    // this.urlLogotipo = '';
    // this.idUsuario = '0';
    // this.idioma = 'esp';
  }
}
